export const buildUrlWeb = (uri: string) => {
  return `/webapp/${uri}`;
};
